import React, { useEffect } from 'react'
import { AutocompleteAjaxSeeker, IconSeeker } from "@ui-seeker/core"
import useAdminNewOfficeInfo from "Pages/Admin/Users/@hooks/useNewOfficeInfo"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"
import { BACKEND_APIS } from "@constants"
import { isValidNewOffice } from "Pages/Admin/Users/@signals"
import { Box, Typography } from "@mui/material"


export default function OfficeTypeField() {
	const { officeType, setOfficeTypeInfo } = useAdminNewOfficeInfo("", "officeType")
	const {
		errors,
		isValid
	} = useValidatorSeeker({ officeType: officeType }, object({ officeType: string().required('Must provide an office type') }))
	const icon = {
		Airport: 'plane-departure',
		Downtown: 'city',
		Truck: 'truck',
		"Train Station": 'train'
	}

	useEffect(() => {
		isValidNewOffice.value = { ...isValidNewOffice.value, officeType: isValid }
	}, [isValid])

	return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		value={officeType}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/all/options/office-types`}
		onChange={e => setOfficeTypeInfo(e.target.value)}
		formatOptionLabel={({ label }) => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 1 }}>
			<IconSeeker icon={icon[label]}/>
			<Typography>{label}</Typography>
		</Box>}
		label="Office Type"
		placeholder="Office Type"
		error={errors.officeType}
	/>
}